import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';

class KPSGetUserInfoAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "KpsGetInfoUser";
    super(baseUrl);
  }


  getKPSGetUserInfoListe(tc: string,dogumTarihi: string,username: string,isForeign:boolean){
    
        var request= new KPSGetUserInfoRequest(tc,dogumTarihi,username);
        if(isForeign){
          return this.post("getUserInfoYabanci",request,true);
      
         }else{
          return this.post("getUserInfo", request, true);
        }
   
  }

}
export default new KPSGetUserInfoAPI();
class KPSGetUserInfoRequest {
  public tc: string;
  public dogumTarihi: string;
  public username: string;
  constructor(tc: string,dogumTarihi: string,username: string) {
     
        this.tc = tc;
        this.dogumTarihi = dogumTarihi;
        this.username=username;
    
    }
}
export { KPSGetUserInfoRequest };